import styled, { css } from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

interface IPlanStatusProps {
  isActive?: boolean;
}

interface IContainerType {
  containerType: 'grid' | 'column';
}

export const Container = styled.section`
  display: flex;
  align-items: flex-start;
  column-gap: 6.4rem;
  row-gap: 2.4rem;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    align-items: center;
    margin: 1.6rem auto;
    width: 90%;
  }
`;

export const Content = styled.section`
  width: 100%;
  max-width: 680px;
  padding: 2.4rem;
  overflow-y: auto;

  /* &::-webkit-scrollbar {
    display: none;
  } */

  background: #fff;
  border-radius: 0.6rem;
`;

export const UserAvatar = styled.img`
  object-fit: cover;
  width: 100px;
  height: 100px;
`;

export const Title = styled.h2`
  font-size: 2.8rem;
  color: #0f0f0f;
  letter-spacing: 0.168rem;
  text-transform: uppercase;

  @media (max-width: ${breakpoints.medium}) {
    text-align: center;
  }
`;

export const Header = styled.section`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 2.4rem;
  margin-bottom: 2.4rem;

  section {
    display: flex;
    flex-direction: column;

    div {
      display: flex;
      align-items: center;

      h3 {
        padding: 0;
        margin: 0;
      }

      .item-value {
        margin-left: 1rem;
        font-weight: normal;
      }
    }
  }

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const InfosContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 3.2rem;
  column-gap: 6.4rem;

  @media (max-width: ${breakpoints.medium}) {
    grid-template-columns: 1fr;
  }
`;

export const InfosItem = styled.div`
  font-size: 1.4rem;
`;

export const InfosItemTitle = styled.h3`
  margin-bottom: 1.6rem;
`;

export const InfosItemValue = styled.a``;

export const Footer = styled.section`
  display: flex;
  justify-content: flex-start;
  margin-top: 2.4rem;
  gap: 1.6rem;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Aside = styled.aside`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 4rem;
  max-width: 383px;
  width: 100%;

  @media (max-width: ${breakpoints.medium}) {
    max-width: 100%;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const AsideCard = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 2.4rem;
  padding: 2.4rem 4rem;
  background: #fff;
  border-radius: 0.6rem;
  width: 100%;
`;

export const AsideCardTitle = styled.h3`
  font-size: 2.8rem;
  text-align: center;
  text-transform: uppercase;
  color: #0f0f0f;
  letter-spacing: 0.168rem;
`;

export const AsideCardInsideContainer = styled.div<IContainerType>`
  ${({ containerType }) =>
    containerType === 'grid'
      ? css`
          display: grid;
          width: 100%;
          grid-template-columns: 1fr 1fr;
          grid-gap: 20px;
        `
      : css`
          display: flex;
          width: 100%;
          flex-direction: column;
          row-gap: 2.2rem;
        `}
`;

export const AsideCardItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  text-align: center;
  font-weight: bold;
  color: #0f0f0f;
`;

export const AsideCardItemValue = styled.div`
  margin-left: 0.8rem;
  font-weight: normal;
`;

export const PackagesButton = styled.section`
  font-size: 1.8rem;
  color: #0f0f0f;
  background: #fff;
  border-radius: 5rem;
  padding: 0.8rem;
  border: 0.1rem solid #0f0f0f;
  max-width: 30rem;
  width: 100%;
  text-align: center;
  transition: 0.3s;

  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.colors.yellow};
    transition: 0.3s;
  }
`;

export const PlanStatusitem = styled.p<IPlanStatusProps>`
  width: 100%;
  max-width: 30rem;
  height: 4rem;

  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 1.8rem;
  font-weight: 700;

  ${({ isActive }) =>
    isActive
      ? css`
          color: #101010;
          background: #04c230;
        `
      : css`
          color: #fff;
          background: #c20400;
        `}
`;

export const PlanStatusValueSpan = styled.span<IPlanStatusProps>`
  color: #fff;
  font-weight: initial;
  margin-left: 0.8rem;

  ${({ isActive }) =>
    isActive
      ? css`
          color: #101010;
        `
      : css`
          color: #fff;
        `}
`;

export const PlanStatusSinceDate = styled.p``;

export const PlanStatusSinceDateSpan = styled.span`
  font-weight: 700;
`;
